export default __webpack_public_path__ + "static/media/pic1.ff38dc80.jpg";